import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";

interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Anzeige Text.
     */
    text: string,

    /**
     * Das zugeordnete Datum.
     */
    date: moment.Moment,

    /**
     * Angabe, ob das Item im selektierten Datumsbereich ist.
     */
    isDateInSelectedRange: boolean,

    /**
     * Angabe, ob das Item außerhalb des angezeigten Monats ist.
     */
    isOutsideCurrentMonth: boolean,

    /**
     * Angabe, ob das Item der heutige Tag ist.
     */
    isToday: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (date: moment.Moment) => void
}

export class DayItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { date, onClick } = this.props;
        onClick && onClick(date);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var { style, text, isDateInSelectedRange, isOutsideCurrentMonth, isToday } = this.props;
        var classNames: string[] = ["datepicker_calendar_day"];

        if (isDateInSelectedRange)
            classNames.push("datepicker_calendar_day--in-selected-range");

        if (isOutsideCurrentMonth)
            classNames.push("datepicker_calendar_day--outside-month");

        if (isToday)
            classNames.push("datepicker_calendar_day--today");

        return (
            <div
                className={classNames.join(" ")}
                style={style}
                onClick={this.onClick}>
                {text}
            </div>
        );
    }
}